<div id="findbarMessageContainer" aria-live="polite">
  <span id="findResultsCount" class="toolbarLabel"></span>
  <span id="findMsg" class="toolbarLabel"></span>
</div>
